export const USER_ACTION_TYPES = {
    SET_USER: "SET_USER"
};